import { WorkerConfigurationApiMode } from './worker-configuration.api';

/**
 * Workflow options that only support may configure.
 * Provider UI shows them read-only and must not write or default them.
 */
const SUPPORT_ONLY_WORKFLOW_OPTIONS: Readonly<Record<string, ReadonlySet<string>>> = {
    EXECUTE_ENTER_CODING: new Set(['codingClaimTags']),
    NEED_MEDICAL_RECORDS: new Set(['uploadDocuments']),
    WAIT_FOR_PROFESSIONAL_CREATED: new Set(['waitForCoding']),
};

/** True when the option can only be edited from the support tool. */
export function isSupportOnlyWorkflowOption(status: string, key: string): boolean {
    return SUPPORT_ONLY_WORKFLOW_OPTIONS[status]?.has(key) ?? false;
}

/** True when the current API mode may edit the option. */
export function canEditWorkflowOption(
    apiMode: WorkerConfigurationApiMode,
    status: string,
    key: string,
): boolean {
    if (apiMode === 'support') {
        return true;
    }

    return !isSupportOnlyWorkflowOption(status, key);
}
